<h1 mat-dialog-title>Allocations</h1>
<div mat-dialog-content>
  <table mat-table [dataSource]="dataSource">
    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="Article">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Article</th>
      <td mat-cell *matCellDef="let element">{{ element.Article }}</td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="DescLien">
      <th mat-header-cell *matHeaderCellDef>Desc.</th>
      <td mat-cell *matCellDef="let element">{{ element.DescLien }}</td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="QteAllouee">
      <th mat-header-cell *matHeaderCellDef>Qte Allouée</th>
      <td mat-cell *matCellDef="let element">{{ element.QteAllouee }}</td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="QteReelle">
      <th mat-header-cell *matHeaderCellDef>Qte Réelle</th>
      <td mat-cell *matCellDef="let element">{{ element.QteReelle }}</td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="Unit">
      <th mat-header-cell *matHeaderCellDef>Unité</th>
      <td mat-cell *matCellDef="let element">{{ element.Unit }}</td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="DateAlloc">
      <th mat-header-cell *matHeaderCellDef>Date Alloc.</th>
      <td mat-cell *matCellDef="let element">{{ element.DateAlloc }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    [mat-dialog-close]="true"
    cdkFocusInitial
    class="mat-raised-button mat-primary"
  >
    Ok
  </button>
</div>
